<template>
    <div class="container remove-padding-margin">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClickedloader === true"></span>
        </div>
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <div class="remove-margin">Login Email</div>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 mar-top-60">
                    <div class="line-height-25 letter-space-002 color-0000 font-16">Email yang digunakan untuk login Smartlink Owner saat ini adalah:</div>
                    <div class="font-18 line-height-25 letter-space-002 color-0000 font-weight-600 mar-top-16 mar-bottom-20 d-flex align-items-center">
	                    <div class="row m-0 w-100 d-flex align-items-center">
		                    <div class="col-8 p-0">
			                    <input type="text" class="w-100" readonly style="border: none; outline: none"
			                           :value="email_owner" id="copied_email">
		                    </div>
		                    <div class="col-4 text-right p-0">
			                    <button class="btn btn-outline-primary" @click="copyToClipboard">Salin</button>
		                    </div>
	                    </div>
                    </div>
	
	                <div class="row" style="margin: 0 -20px 20px -20px; border-top: 1px solid #EDEDED; border-bottom: 1px solid #EDEDED; padding: 12px 20px"
	                     @click="kirimUlangVerifikasiEmail"
	                    v-if="owner.verified_email === 0 && !owner.email.includes('OWN')">
		                <div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0">
			                <i class="fas fa-exclamation-triangle f-c-midgrey"></i>
		                </div>
		                <div class="col-lg-10 col-md-10 col-sm-10 col-10">
			                <div class="letter-space-002 f-c-midgrey font-12">
				                Email belum terverifikasi. Periksa kotak masuk email anda. Tidak menerima verifikasi?<br>
				                <span class="f-c-blue"><u>Kirim ulang verifikasi</u></span>
			                </div>
		                </div>
	                </div>
	
	                <div class="row" style="margin: 0 -20px 20px -20px; border-top: 1px solid #EDEDED; border-bottom: 1px solid #EDEDED; padding: 12px 20px"
	                    v-if="owner.verified_email === 0 && owner.email.includes('OWN')">
		                <div class="col-lg-1 col-md-1 col-sm-1 col-1 p-0">
			                <i class="fas fa-info-circle f-c-midgrey"></i>
		                </div>
		                <div class="col-lg-10 col-md-10 col-sm-10 col-10">
			                <div class="letter-space-002 f-c-midgrey font-12">
				                Anda belum mengatur email untuk akun ini! Email diatas dibuat otomatis oleh sistem,
				                Anda dapat merubah menggunakan email Anda sendiri.
			                </div>
		                </div>
	                </div>
	                
					<!--<div v-if="status_password ==='tidak_ada'">-->
	                <div v-if="email_owner.includes('OWN')">
                        <button type="button" class="btn btn-outline-primary btn-long mar-bot-12" id="btn1" @click="goCreateEmail">Ubah Email</button>
                        <button type="button" class="btn btn-outline-primary btn-long" id="btn2" @click="goCreateEmail"
                            v-if="!owner.email.includes('OWN')">
	                        Buat Kata Sandi
                        </button>
                    </div>
                    <div v-else>
                        <button type="button" class="btn btn-outline-primary btn-long mar-bot-12" id="btn3" @click="tipeAction(1)">Ubah Email</button>
                        <button type="button" class="btn btn-outline-primary btn-long" id="btn4" @click="tipeAction(2)" v-if="set_password === 1">Ubah Kata Sandi</button>
	                    <button type="button" class="btn btn-outline-primary btn-long" @click="this.gosetpass" v-else>Ubah Kata Sandi</button>
                    </div>
                </div>
            </div>
        </main>


        <div class="modal fade" id="modalsecurepass" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Verifikasi Keamanaan</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div>Silakan masukkan kata sandi saat ini untuk memastikan keamanan akun Anda.</div>
                        <label for="inputPass" class="line-height-25 font-14 color-6f7 text-login-wa require mar-top-16 mar-bot-2">Kata sandi saat ini</label>
                        <input type="password" class="form-control inputs" id="inputPass" @keyup="inputpassword" v-on:keyup="listenCapslock($event, 'inputPass')" v-model="password">
                        <span toggle="#password-field" v-on:click="changeViewPass"
                              class="fa fa-eye field-icon toggle-password"></span>
	                    <ErrorMessage class="error" label="Password" :validation="$v.password"></ErrorMessage>
                        <div class="mar-top-8" @click="forgotpass"><span class="color-206CF font-14">Lupa kata sandi</span></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" id="btnsecure" @click="verifikasipass">Berikutnya</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "LoginOwnerEmail",
	    components: { ErrorMessage },
        data(){
          return{
              telp:'',
              owner:{},
              email_owner:'',
              password:'',
              password1:'',
              status_password:'',
              isClickedloader:true,
	          tipeActionValue: "",
              requestHeaders: {
                  headers: {
                      'Authorization': 'Bearer ' + localStorage.getItem('token'),
                  }
              }
          }
        },
	    validations: {
		    password: {
		    	required,
			    minLength: minLength(6),
		    }
	    },
        mounted(){
            this.getdetailowner()
            this.getpasswordowner()
        },
        methods: {
	        copyToClipboard() {
		        var copyText = document.getElementById("copied_email");
		        copyText.select();
		        copyText.setSelectionRange(0, 99999)
		        document.execCommand("copy");

		        this.$toast.success("Akun email tersailn")
		    },
        	
            back() {
                this.$router.push('/detailakunowner')
            },

            gosetpass(){
                this.$router.push('/createpassword')
            },

            goeditemail(){
                this.$router.push('/editemail')
            },

            forgotpass(){
                this.$router.push({name: 'forgotpassword', params: { type:2}});
                $('#modalsecurepass').modal('hide');
            },

            cekValidatepass() {
	        	return
                var passData = this.password;
                var lenPass = passData.length;
                if (lenPass >= 6) {
                    $('#btnsecure').prop('disabled', false);
                } else {
                    $('#btnsecure').prop('disabled', true);
                }
            },

            inputpassword(event){
                var name = event.target.value;
                var handle = name.replace(/[ ]+/,'');
                this.password = handle;
                this.cekValidatepass()
            },

            changeViewPass(event) {
                if ($('#inputPass').attr("type") == "password") {
                    $('.toggle-password').removeClass('fa fa-eye');
                    $('.toggle-password').addClass('fa fa-eye fa-eye-slash');
                    $('#inputPass').attr("type", "text");
                } else {
                    $('.toggle-password').removeClass('fa fa-eye fa-eye-slash');
                    $('.toggle-password').addClass('fa fa-eye');
                    $('#inputPass').attr("type", "password");
                }
            },



            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
                    this.owner = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
	                    this.set_password = res.data.set_password
                        this.email_owner = dataowner.email
                    }else{
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
                }
            },

            async getpasswordowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/owner/cek_password_owner',  this.requestHeaders);
                    this.status_password = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataownerpass = res.data.data
                        this.status_password = dataownerpass.status_pass_owner;
                    }else{
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
                }
            },

	        tipeAction(tipe) {
	        	$("#modalsecurepass").modal('show')
	        	this.tipeActionValue = tipe
	        },
            async verifikasipass(){
	        	if (this.$v.password.$invalid) {
			        this.$v.password.$touch()
			        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
	        		return
		        }
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').hide();
                this.isClickedloader = true;
                try {
                    const verifikasi = new FormData;
                    verifikasi.append('password', this.password);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/verifikasi_password_owner_sekarang', verifikasi,this.requestHeaders)
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                        this.password ='';
                        if (this.email_owner.includes("OWN")) {
                        	this.goeditemail()
                        } else {
                        	if (this.tipeActionValue === 1) {
		                        this.goeditemail()
	                        } else {
		                        this.gosetpass()
	                        }
                        }
                        $("#modalsecurepass").modal("hide");
                    }else{
                        this.password1 ='';
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                        this.$toast.error(res.data.msg)
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false;
                }
            },
            async kirimUlangVerifikasiEmail() {
	            $('#loadingPage').addClass('overlayLoading');
	            this.isClickedloader = true;
	        	try {
	        		var formData = new FormData()
			        formData.append("email", this.email_owner)
	        		const res = await this.$axios.post(this.$baseurl + '/auth/send_verifikasi_ubah_email_baru', formData, this.requestHeaders)
			        if (res.data.status) {
				        $('#loadingPage').removeClass('overlayLoading');
				        this.isClickedloader = false;
				        
				        this.$router.push(`/successchangeemail/${this.email_owner}`)
			        } else {
				        $('#loadingPage').removeClass('overlayLoading');
				        this.isClickedloader = false;
			        	
				        this.$toast.error(res.data.msg)
			        }
		        } catch (e) {
	        		this.$catch_error_response(e)
			        $('#loadingPage').removeClass('overlayLoading');
			        this.isClickedloader = false;
		        }
            },
	        goCreateEmail() {
	        	this.$router.push("setemailowner")
	        }
        }
    }
</script>

<style scoped>

</style>